export const UPDATE_UNITS = 'UPDATE_UNITS';
export const UPDATE_UNITS_FROM_BACKEND = 'UPDATE_UNITS_FROM_BACKEND';
export const SET_UNITS = 'SET_UNITS';
export const SET_HLA_MAP_UNITS = 'SET_HLA_MAP_UNITS';
export const ADD_HLA_UNIT = 'ADD_HLA_UNIT';
export const SET_HLA_UNITS = 'SET_HLA_UNITS';
export const ADD_UNIT = 'ADD_UNIT';
export const DELETE_UNITS = 'DELETE_UNITS';
export const CH_UNIT_SELECTED = 'CH_UNIT_SELECTED';

export const SIDES_ADDED = 'SIDES_ADDED';
export const FACTIONS_ADDED = 'FACTIONS_ADDED';
export const PROTOTYPES_ADDED = 'PROTOTYPES_ADDED';
export const OBSTACLES_ADDED = 'OBSTACLES_ADDED';

export const ADD_COMMAND_TO_UNIT = 'ADD_COMMAND_TO_UNIT';
export const REMOVE_COMMAND_FROM_UNIT = 'REMOVE_COMMAND_FROM_UNIT';

export const SITREP_UNIT_SELECT = 'SITREP_UNIT_SELECT';
export const SITREP_UNIT_DESELECT = 'SITREP_UNIT_DESELECT';
export const SITREP_CHANGE_VISUAL_ACTIVE = 'SITREP_CHANGE_VISUAL_ACTIVE';
export const RESET_SITREP_SELECTED_UNITS = 'RESET_SITREP_SELECTED_UNITS';

export const MISREP_COMMAND_SELECT = 'MISREP_COMMAND_SELECT';
export const MISREP_COMMAND_DESELECT = 'MISREP_COMMAND_DESELECT';
export const RESET_MISREP_SELECTED_UNITS = 'RESET_MISREP_SELECTED_UNITS';

export const MISREP_UNIT_SELECT = 'MISREP_UNIT_SELECT';
export const MISREP_UNIT_DESELECT = 'MISREP_UNIT_DESELECT';

export const TOGGLE_SITREP_UNIT_UNVISIBLE = 'SET_SITREP_UNIT_UNVISIBLE';
export const TOGGLE_MISREP_UNIT_UNVISIBLE = 'SET_MISREP_UNIT_UNVISIBLE';

export const TOGGLE_SITREP_DOCK = 'TOGGLE_SITREP_DOCK';
export const TOGGLE_MISREP_DOCK = 'TOGGLE_MISREP_DOCK';
export const TOGGLE_COMMAND_QUEUE_DOCK = 'TOGGLE_COMMAND_QUEUE_DOCK';

export const CHANGE_SITREP_POSITION = 'CHANGE_SITREP_POSITION';
export const CHANGE_MISREP_POSITION = 'CHANGE_MISREP_POSITION';
export const CHANGE_COMMAND_QUEUE_POSITION = 'CHANGE_COMMAND_QUEUE_POSITION';

export const COMMAND_QUEUE_UNIT_SELECT = 'COMMAND_QUEUE_UNIT_SELECT';
export const COMMAND_QUEUE_UNIT_DESELECT = 'COMMAND_QUEUE_UNIT_DESELECT';
export const RESET_COMMAND_QUEUE_SELECTED_UNITS = 'RESET_MISREP_SECOMMAND_QUEUE_UNITS';

export const COMMAND_QUEUE_COMMAND_SELECT = 'COMMAND_QUEUE_COMMAND_SELECT';
export const COMMAND_QUEUE_COMMAND_DESELECT = 'COMMAND_QUEUE_COMMAND_DESELECT';

export const SET_LAST_ACTIVE_BAR = 'SET_LAST_ACTIVE_BAR';
export const CHANGE_WEIGHT_UNIT = 'CHANGE_WEIGHT_UNIT';
export const FILTER_UNITS = 'FILTER_UNITS';
